import { z } from 'zod';

export const updateMeSchema = z
  .object({
    notifications_enabled: z.boolean().optional(),
    /** null — вернуться к языку Telegram */
    language: z.enum(['ru', 'uz']).nullable().optional(),
  })
  .strict();

export type UpdateMeInput = z.infer<typeof updateMeSchema>;
